<template>
  <div>
    <div v-html="placeholder.content"></div>
    <div class="text-xs-right">
          <rp-icon
            v-if="isAdmin"
            type="edit"
            tooltip="edytuj"
            @click="$emit('change-placeholder')"
          />
          <rp-icon
            v-if="isAdmin"
            type="delete"
            tooltip="usuń"
            @click="$emit('remove-placeholder')"
          />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    placeholder: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PlaceholderItem.vue